import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Globe, Lock } from 'lucide-react';

export const VisibilitySelector = ({ onSelect }) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        setSelected(prev => prev === null ? true : !prev);
      }
      if (e.key === 'Enter' && selected !== null) {
        e.preventDefault();
        onSelect(selected);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selected, onSelect]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="gm-visibility-row"
    >
      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={() => onSelect(true)}
        className={`gm-visibility-btn ${selected === true ? 'gm-visibility-btn--active' : ''}`}
      >
        <div className="gm-visibility-icon gm-visibility-icon--public">
       <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M11 20.1663C16.0626 20.1663 20.1666 16.0623 20.1666 10.9997C20.1666 5.93706 16.0626 1.83301 11 1.83301C5.93737 1.83301 1.83331 5.93706 1.83331 10.9997C1.83331 16.0623 5.93737 20.1663 11 20.1663Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11 1.83301C8.64619 4.30448 7.33331 7.58669 7.33331 10.9997C7.33331 14.4127 8.64619 17.6949 11 20.1663C13.3538 17.6949 14.6666 14.4127 14.6666 10.9997C14.6666 7.58669 13.3538 4.30448 11 1.83301Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1.83331 11H20.1666" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </div>
        <div className="gm-visibility-text">
          <h3 className="gm-visibility-title">Public</h3>
          <p className="gm-visibility-desc">Anyone can trade</p>
        </div>
      </motion.button>

      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={() => onSelect(false)}
        className={`gm-visibility-btn ${selected === false ? 'gm-visibility-btn--active' : ''}`}
      >
        <div className="gm-visibility-icon gm-visibility-icon--private">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.4167 10.083H4.58333C3.57081 10.083 2.75 10.9038 2.75 11.9163V18.333C2.75 19.3455 3.57081 20.1663 4.58333 20.1663H17.4167C18.4292 20.1663 19.25 19.3455 19.25 18.333V11.9163C19.25 10.9038 18.4292 10.083 17.4167 10.083Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.41669 10.083V6.41634C6.41669 5.20077 6.89957 4.03498 7.75911 3.17544C8.61866 2.31589 9.78444 1.83301 11 1.83301C12.2156 1.83301 13.3814 2.31589 14.2409 3.17544C15.1005 4.03498 15.5834 5.20077 15.5834 6.41634V10.083" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        </div>
        <div className="gm-visibility-text">
          <h3 className="gm-visibility-title">Private</h3>
          <p className="gm-visibility-desc">Invite only</p>
        </div>
      </motion.button>
    </motion.div>
  );
};
